import { List, ListItem } from "@mui/material";
import { Trafikkregulering } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";

import trafikkreguleringIconResource from "../../assets/trafikkregulering.svg"

export default function Trafikkreguleringer(props: IRoutePartProps) {

    return (
        <>
            {props.roadFeatures && props.roadFeatures.trafikkreguleringer && props.roadFeatures.trafikkreguleringer.length > 0 &&
            <List>
                {props.roadFeatures.trafikkreguleringer.map((trafikkregulering: Trafikkregulering, index: number) => {
                    return <ListItem
                    key={trafikkregulering.nvdbId + index}
                    className="roadFeature"
                    onClick={(event) => {props.onClick(trafikkregulering, event)}}
                    onMouseEnter={() => props.onMouseEnterItem(trafikkregulering)}
                    onMouseLeave={props.onMouseLeaveItem}>
                        <img src={trafikkreguleringIconResource} height="18" style={{paddingRight:"5px"}} alt="Trafikkregulering icon" title="trafikkreguleringVegIcon"/> {trafikkregulering.nvdbId}
                    </ListItem>
                })}
            </List>
            }
        </>
    )

}